// src/pages/Dashboard.js
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { FaBoxes, FaChartLine, FaDollarSign, FaCogs, FaPlay } from 'react-icons/fa';
import Header from '../components/Header';
import Navbar from '../components/Navbar';

const features = [
  {
    key: 'inventory',
    title: 'Inventory Management',
    subtitle: 'Real-time stock control',
    text: 'Track and update stock levels across all locations in real time. Receive low-stock alerts and automate reorder processes.',
    icon: <FaBoxes size={40} className="mb-3 text-primary" />,
    btnText: 'Manage Inventory',
  },
  {
    key: 'demand',
    title: 'Demand Forecasting',
    subtitle: 'Predict future needs',
    text: 'Use historical data and AI models to predict future demand and optimize your replenishment strategy.',
    icon: <FaChartLine size={40} className="mb-3 text-success" />,
    btnText: 'Forecast Now',
  },
  {
    key: 'pricing',
    title: 'Pricing Optimization',
    subtitle: 'Maximize revenue',
    text: 'Automatically recommend optimal prices to maximize revenue and stay competitive in the market.',
    icon: <FaDollarSign size={40} className="mb-3 text-warning" />,
    btnText: 'Optimize Pricing',
  },
  {
    key: 'orchestration',
    title: 'Orchestration',
    subtitle: 'Run simulations',
    text: 'Run advanced supply-chain simulations and scenario analyses to fine-tune your operations.',
    icon: <FaPlay size={40} className="mb-3 text-info" />,
    btnText: 'Launch Simulation',
  },
  {
    key: 'config',
    title: 'Configuration',
    subtitle: 'Custom settings',
    text: 'Adjust global settings, user roles, and feature flags to tailor the platform to your business needs.',
    icon: <FaCogs size={40} className="mb-3 text-secondary" />,
    btnText: 'Edit Settings',
  },
];

export default function Dashboard({ setPage }) {
  return (
    <Container className="card-transparent p-4 text-center">
      <Header />
      <Navbar setPage={setPage} />

      {/* Tagline */}
      <div className="mb-5">
        <h1 className="fw-bold">Welcome to RETAIL AI</h1>
        <p className="lead text-muted">
          Your centralized hub to manage inventory, forecast demand, optimize pricing, and automate workflows.
        </p>
      </div>

      {/* Feature Cards */}
      <Row className="justify-content-center g-4">
        {features.map(({ key, title, subtitle, text, icon, btnText }) => (
          <Col key={key} xs={12} sm={10} md={6} lg={4}>
            <Card
              className="h-100 shadow-sm border-0"
              style={{ background: 'rgba(255, 255, 255, 0.85)', transition: 'transform .2s, box-shadow .2s' }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 6px 18px rgba(0,0,0,0.12)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
              }}
            >
              <Card.Body className="d-flex flex-column align-items-center">
                {icon}
                <Card.Title className="fw-bold">{title}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">{subtitle}</Card.Subtitle>
                <Card.Text className="flex-grow-1">{text}</Card.Text>
                <Button variant="primary" onClick={() => setPage(key)}>
                  {btnText}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
